import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, ButtonModel } from '@notino/react-styleguide';
import { AvailabilityState } from '@notino/shared/definitions/types';

import { useFetchProductAlternatives } from '@containers/ProductDetailContainer/hooks/useFetchProductAlternatives';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { dispatchTrackingEvent } from '@context/tracking/utils';

import { ShowOnDesktop } from '../../styled';
import { productBaseInfoMessages } from '../messages';

export const SimilarProductsButton = () => {
  const { data } = useFetchProductAlternatives();
  const { product } = useProductDetailContext();
  const { getTimeFromInit } = useTrackingContext();
  const { experiment_pd_outofstock_product_alternatives } = useFeatureFlags();

  const alreadyFetchedButNoProducts =
    data &&
    Boolean(data.getOutOfStockAlternatives?.recommendedProducts?.length) ===
      false;

  const everyProductUnavailable = product.variants.every(
    (v) => v.availability.state !== AvailabilityState.CanBeBought
  );

  if (
    !experiment_pd_outofstock_product_alternatives ||
    alreadyFetchedButNoProducts ||
    !everyProductUnavailable
  ) {
    return null;
  }

  return (
    <ShowOnDesktop>
      <Button
        href="#product-alternatives"
        onClick={() =>
          dispatchTrackingEvent({
            event: 'element_click',
            _clear: true,
            element: {
              timing: getTimeFromInit(),
              name: 'product_alternatives',
              type: 'product_detail',
              interaction: 'button',
            },
          })
        }
        buttonStyle={ButtonModel.Styles.secondary}
      >
        <FormattedMessage {...productBaseInfoMessages.similarProductsButton} />
      </Button>
    </ShowOnDesktop>
  );
};
